import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  vOffset?: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, vOffset, ...other } = props;

  return (
    <div
      style={{ padding: 0, margin: 0 }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index &&
        <Box
          sx={{
            paddingTop: "11px",
            width: "100%",
            height: `calc(100vh - ${vOffset || 251}px)`,
          }}
        >
          {children}
        </Box>
      }
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export interface TabSelectorProps {
  vOffset?: number;
  tabs: {
    [key: string]: {
      component: React.ReactNode;
      disabled?: boolean;
    }
  }
}

export function TabSelector({ tabs, vOffset }: TabSelectorProps) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const tabArray = Object.keys(tabs).map((key, index) => {
    const { component, disabled } = tabs[key];
    return {
      label: key,
      component: component,
      disabled: disabled,
      index: index
    }
  });
  if (tabArray[value]?.disabled) {
    setValue(0);
  }
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{
        borderBottom: 1,
        borderColor: 'divider',
      }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" textColor="secondary"
          indicatorColor="secondary">
          {tabArray.map((tab, index) => (
            <Tab
            sx={{
              '&.Mui-disabled': {
                color: '#5c5c5c', 
                opacity: .5,       
              },
            }}

              key={index}
              label={tab.label}
              {...a11yProps(index)}
              disabled={tab.disabled}
            />
          ))}
        </Tabs>
      </Box>
      {tabArray.map((tab, index) => (
        <CustomTabPanel key={index} value={value} vOffset={vOffset} index={index}>
          {tab.component}
        </CustomTabPanel>
      ))}
    </Box>
  );
}
